/**
 * Utility for managing onboarding status in localStorage
 * Provides non-blocking access to onboarding status with background sync
 */

const STORAGE_KEY = 'onboarding_status';

/**
 * Get onboarding status from localStorage
 * @returns {string|null} The onboarding status value or null if not found
 */
export function getOnboardingStatusFromStorage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored !== null ? stored : null;
  } catch (e) {
    console.warn('[OnboardingStorage] Failed to read from localStorage:', e);
    return null;
  }
}

/**
 * Save onboarding status to localStorage
 * @param {string|number} status - The onboarding status value
 */
export function saveOnboardingStatusToStorage(status) {
  try {
    localStorage.setItem(STORAGE_KEY, String(status));
    console.log(`[OnboardingStorage] Saved onboarding status to localStorage: ${status}`);
  } catch (e) {
    console.warn('[OnboardingStorage] Failed to save to localStorage:', e);
  }
}

/**
 * Clear onboarding status from localStorage
 */
export function clearOnboardingStatusFromStorage() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    console.log('[OnboardingStorage] Cleared onboarding status from localStorage');
  } catch (e) {
    console.warn('[OnboardingStorage] Failed to clear localStorage:', e);
  }
}
